export default __webpack_public_path__ + "static/media/FRACTAL Bananice.cf37a576.jpg";